import React from 'react';
import {
  ENGLISH,
  MEETING_AUDIT_STATUS,
  MEETING_FILTER_TYPE,
  MEETING_STATUS,
  PATHS,
  ROLES_KEY
} from '../../utils/constants';
import { FormattedMessage } from 'react-intl';
import { Button, DatePicker, Icon, Input, InputNumber, Modal, Spin, Table } from 'antd';
import RejectTip from '../../components/AuditManage/RejectTip';
import en_us from 'rc-pagination/lib/locale/en_US';
import zh_cn from 'rc-pagination/lib/locale/zh_CN';
import MoreMeeting from '../meeting/MoreMeeting';
import { routerRedux } from 'dva/router';
import pathToRegexp from 'path-to-regexp';
import { checkOperateAuth } from '../../utils/meetingUtil';
import './MeetingList.less';

class MeetingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      highSearchSwitch: false,
      delayModalMinute: 0,
      delayArray: [],
      selectedMeetingIds: [],
      selectedMeetingData: [],
      maxDelay: 0,
      minDelay: 0,
      delayModal: false,
      currentMeetingId: 0
    };
  }

  componentDidMount() {
  }

  render() {
    const {meetingList, intl, dispatch, meetingPolicy, userInfo, locale} = this.props;
    const {selectedMeetingIds, selectedMeetingData} = this.state;
    const delayBlock = [];
    this.state.delayArray.map((time, i) => {
      delayBlock.push(<div
        key={i}
        className={
          this.state.delayModalMinute == time ? 'minute_div minute_div_selected' : 'minute_div'
        }
        onClick={() => {
          this.setState({delayModalMinute: time});
        }}
      >
        {time + ' ' + intl.formatMessage({id: 'monitor_alarm_minutes'})}
      </div>);
    });
    const {data, meetingTree} = meetingList;
    if (data) {
      MeetingList.defaultProps.total = data.total;
      MeetingList.defaultProps.currentPage = data.pageNo;
    }

    const pagination = {
      onChange: (current, pageSize) => {
        MeetingList.defaultProps.currentPage = current;
        MeetingList.defaultProps.pageSize = pageSize;
        dispatch({
          type: 'meetingList/allMeeting',
          payload: Object.assign({}, MeetingList.defaultProps, {type: 3})
        });
      },
      onShowSizeChange: (current, pageSize) => {
        MeetingList.defaultProps.currentPage = current;
        MeetingList.defaultProps.pageSize = pageSize;
        dispatch({
          type: 'meetingList/allMeeting',
          payload: Object.assign({}, MeetingList.defaultProps, {type: 3})
        });
      },
      current: MeetingList.defaultProps.currentPage,
      pageSize: MeetingList.defaultProps.pageSize,
      total: MeetingList.defaultProps.total,
      showQuickJumper: true,
      showSizeChanger: true,
      pageSizeOptions: ['10', '20', '50'],
      locale: intl.formatMessage({id: 'locale'}) === ENGLISH ? en_us : zh_cn
    };

    // 选择tab行
    const rowSelection = {
      selectedRowKeys: selectedMeetingIds,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({selectedMeetingIds: selectedRowKeys, selectedMeetingData: selectedRows});
      },
      getCheckboxProps: record => ({
        disabled: record.status !== 0 && record.status !== 4,
        name: record.id
      })
    };
    const hasSelected = selectedMeetingIds.length > 0;
    const columns = [
      {
        title: <div>{intl.formatMessage({id: 'meeting_list_table_id'})}</div>,
        width: '10%',
        key: 'meetingNo',
        render: record => {
          return (
            <div
              className={`meeting-num`}
              onClick={() => {
                const {id, type} = record;
                dispatch(
                  routerRedux.push(
                    `${PATHS.meetingInfo}?meetingId=${id}&reType=${
                      type > 0 ? 1 : 0
                      }`
                  )
                );
              }}
            >
              {record.meetingNo}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({id: 'meeting_list_table_subject'}),
        width: '15%',
        key: 'title',
        render: record => {
          let cycleIcon = null;
          if (record.type != 0) {
            //循环会议
            cycleIcon = <Icon style={{marginLeft: '10px'}} type="retweet"/>;
          }
          return (
            <div className="table-meeting-title">
              <div title={record.name}>{record.name}</div>
              {cycleIcon}
            </div>
          );
        }
      },
      {
        title: (
          <div>{intl.formatMessage({id: 'meeting_list_table_status'})}</div>
        ),
        width: '10%',
        key: 'status',
        render: record => {
          const {status, roomAudit: auditList = []} = record;
          const remark = this.getRejectRemark(auditList);
          if (status === MEETING_STATUS.pending) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#7DCC53'}}/>
                <span>{intl.formatMessage({id: 'not_start'})}</span>
              </div>
            );
          } else if (status === MEETING_STATUS.opened) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#48B3F6'}}/>
                <span>{intl.formatMessage({id: 're_going'})}</span>
              </div>
            );
          } else if (status === MEETING_STATUS.closed) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#BFBFBF'}}/>
                <span>{intl.formatMessage({id: 're_done'})}</span>
              </div>
            );
          } else if (status === MEETING_STATUS.cancel) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#FEC273'}}/>
                <span>{intl.formatMessage({id: 're_canceled'})}</span>
              </div>
            );
          } else if (status === MEETING_STATUS.reject) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#FD7779'}}/>
                <span>{intl.formatMessage({id: 're_audit_failed'})}</span>
                <RejectTip content={remark}/>
              </div>
            );
          } else if (status === MEETING_STATUS.audit) {
            return (
              <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: '#13c2c2'}}/>
                <span>{intl.formatMessage({id: 're_auditing'})}</span>
              </div>
            );
          }
        }
      },
      {
        title: (
          <div>{intl.formatMessage({id: 'meeting_list_table_room'})}</div>
        ),
        width: '12%',
        key: 'roomNames',
        render: record => {
          let roomNamesEn = '';
          let rooms = [];
          meetingList && meetingList.data && meetingList.data.list.forEach(item => {
            if (item.id === record.id) {
              rooms = item.rooms;
            }
          });
          rooms && rooms.forEach(item => {
            roomNamesEn += item.nameEn + ',';
          });
          return <div className="table-meeting-room">
            <div
              title={record.roomNames}>{intl.locale === 'en_US' ? roomNamesEn.substring(0, roomNamesEn.length - 1):record.roomNames}</div>
          </div>;
        }
      },
      {
        title: (
          <div className="table-item-align">
            {intl.formatMessage({id: 'meeting_list_table_start'})}
          </div>
        ),
        width: '12%',
        key: 'showStartTime',
        dataIndex: 'showStartTime',
        render: record => {
          return (
            <div className="table-item-align">
              <p>{record.split(' ')[0]}</p>
              <p>{record.split(' ')[1]}</p>
            </div>
          );
        }
      },
      {
        title: (
          <div className="table-item-align">
            {intl.formatMessage({id: 'meeting_list_table_end'})}
          </div>
        ),
        width: '10%',
        key: 'showEndTime',
        dataIndex: 'showEndTime',
        render: record => {
          return (
            <div className="table-item-align">
              <p>{record.split(' ')[0]}</p>
              <p>{record.split(' ')[1]}</p>
            </div>
          );
        }
      },
      {
        title: (
          <div>{intl.formatMessage({id: 'meeting_list_table_creator'})}</div>
        ),
        width: '10%',
        key: 'holder',
        render: record => {
          return <div>{record.holder}</div>;
        }
      },
      /*
      {
        title: (
          <div>{intl.formatMessage({id: 'meeting_list_sign_state'})}</div>
        ),
        width: '8%',
        key: 'signState',
        render: record => {

          if (record.needToSign == 0 && record.status !== MEETING_STATUS.audit
            && record.status !== MEETING_STATUS.cancel) {
            let hasSign = record.users && record.users.some(user => user.isSign == '1');
            if (hasSign) {
              return <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: 'rgb(125, 204, 83)'}}/>
                <span>{intl.formatMessage({id: 'meeting_list_table_sign'})}</span>
              </div>;
            } else {
              return <div className={'point-wrapper'}>
                <div className={'point'} style={{backgroundColor: 'rgb(253, 119, 121)'}}/>
                <span>{intl.formatMessage({id: 'meeting_list_table_not_sign'})}</span>
              </div>;
            }
          } else {
            return null;
          }

        }
      },
           */
      {
        title: intl.formatMessage({id: 'meeting_list_table_operate'}),
        render: this.tableOperateRender
      }
    ];

    const statusFilter = [
      {name: intl.formatMessage({id: 'not_start'}), status: '0'},
      {name: intl.formatMessage({id: 're_going'}), status: '1'},
      {name: intl.formatMessage({id: 're_done'}), status: '2'},
      {name: intl.formatMessage({id: 're_canceled'}), status: '3'},
      {name: intl.formatMessage({id: 're_audit_failed'}), status: '4'},
      {name: intl.formatMessage({id: 're_auditing'}), status: '5'}
    ];
    const reserveTypeFilter = [
      {name: intl.formatMessage({id: 'meeting_btn_mine_book'}), code: MEETING_FILTER_TYPE.myBook},
      {name: intl.formatMessage({id: 'meeting_btn_mine_attend'}), code: MEETING_FILTER_TYPE.myAttend}
    ];
    if (!!meetingPolicy.allowRmAdModify && (userInfo.roleKey === ROLES_KEY.room_admin || userInfo.roleKey === ROLES_KEY.admin)) {
      reserveTypeFilter.push({
        name: intl.formatMessage({id: 'meeting_btn_mine_manage'}),
        code: MEETING_FILTER_TYPE.myManage
      });
    }

    return (
      <div className="my_meetings container-left">
        <Spin spinning={meetingList.loading} size="large">
          <Modal visible={this.state.delayModal} footer={null} width={400}>
            <div className="delay_modal_table">
              <div className="meeting_modal_title">
                {intl.formatMessage({id: 'mc_label_extend'})}
                <div
                  onClick={() => {
                    this.setState({delayModal: false});
                  }}
                  className="cute_x"
                >
                  <i className="iconfont icon-x"/>
                </div>
              </div>
              <div className="meeting_modal_content">
                <div className="meeting_modal_minutes_div">
                  {delayBlock}
                </div>
                <div className="input_div">
                  <InputNumber
                    value={this.state.delayModalMinute}
                    precision={0}
                    min={1}
                    max={1440}
                    onChange={value => {
                      this.setState({delayModalMinute: value});
                    }}
                  />
                  <span className="minute_text">{intl.formatMessage({id: 'booking_minutes'})}</span>
                </div>
              </div>
              <div className="meeting_modal_footer">
                <div
                  className="device_button_cancel"
                  onClick={() => {
                    this.setState({delayModal: false});
                  }}
                >
                  {intl.formatMessage({id: 'support_manage_edit_cancel'})}
                </div>
                <div
                  className="device_button_ok"
                  onClick={() => {
                    if (!this.state.delayModalMinute) {
                      Modal.warning({
                        content: intl.formatMessage({id: 'meeting_extend_time_null'}),
                        okText: intl.formatMessage({id: 'support_manage_edit_ok'})
                      });
                      return;
                    }

                    const promise = new Promise((resolve, reject) => {
                      dispatch({
                        type: 'meetingList/delay',
                        payload: {
                          meetingId: this.state.currentMeetingId,
                          minutes: this.state.delayModalMinute,
                          resolve,
                          reject
                        }
                      });
                    });
                    promise.then(
                      () => {
                        this.setState({delayModal: false});
                        Modal.success({
                          title: intl.formatMessage({id: 'dialog_prompt_info'}),
                          content: intl.formatMessage({id: 'meeting_extend_time_success'}),
                          okText: intl.formatMessage({id: 'support_manage_edit_ok'})
                        });
                      },
                      msg => {
                        Modal.error({content: msg});
                      }
                    );
                  }}
                >
                  {intl.formatMessage({id: 'support_manage_edit_ok'})}
                </div>
              </div>
            </div>
          </Modal>

          <div className="meetings_table">

            <div className="meetings_search">
              <div className="first_row">
                <div className="row-wrap">
                  <div className="label_1">
                    <FormattedMessage id="meeting_list_header_status"/>
                  </div>
                  {statusFilter &&
                  statusFilter.map(sf => {
                    let className = 'state_div';
                    if (meetingList.filter.status.some(s => s === sf.status)) {
                      className = 'state_div state_div_selected';
                    }
                    return (
                      <div
                        key={`${sf.status}`}
                        className={className}
                        onClick={() => {
                          dispatch({
                            type: 'meetingList/filterByStatus',
                            payload: {status: sf.status}
                          });
                        }}
                      >
                        {sf.name}
                      </div>
                    );
                  })}
                </div>
                <div className="row-wrap">
                <span className="label_2">
                  <FormattedMessage id="meeting_list_header_convene"/>
                </span>
                  {reserveTypeFilter &&
                  reserveTypeFilter.map(rf => {
                    let className = 'state_div';
                    if (meetingList.filter.reserveType.some(r => r === rf.code)) {
                      className = 'state_div state_div_selected';
                    }
                    return (
                      <div
                        className={className}
                        key={`${rf.code}`}
                        onClick={() => {
                          dispatch({
                            type: 'meetingList/filterByReserveType',
                            payload: { reserveType: rf.code }
                          });
                        }}
                      >
                        {rf.name}
                      </div>
                    );
                  })}
                  <span
                    className="gj_search"
                    onClick={() => {
                      this.setState({
                        highSearchSwitch: !this.state.highSearchSwitch
                      });
                    }}
                  >
                  {
                    locale === ENGLISH ? "" : <FormattedMessage id="meeting_list_header_advanced_search"/>
                  }
                    &nbsp;
                    <Icon type={this.state.highSearchSwitch ? 'up' : 'down'}/>
                </span>
                  {this.state.highSearchSwitch ? null : (
                    <div
                      className="meeting_button button_ghost btn_reset"
                      onClick={() => {
                        dispatch({type: 'meetingList/reset', payload: {}});
                      }}
                    >
                      <FormattedMessage id="index_reset"/>
                    </div>
                  )}
                </div>
              </div>
              {this.state.highSearchSwitch ? (
                <div className="second_row">
                  <DatePicker
                    value={meetingList.filter.startDateMoment}
                    placeholder={intl.formatMessage({
                      id: 'meeting_placeholder_start_date'
                    })}
                    onChange={(moment, dateStr) => {
                      dispatch({
                        type: 'meetingList/setFilter',
                        payload: {startDate: dateStr, startDateMoment: moment}
                      });
                    }}
                  />
                  <DatePicker
                    value={meetingList.filter.endDateMoment}
                    placeholder={intl.formatMessage({
                      id: 'meeting_placeholder_end_date'
                    })}
                    onChange={(moment, dateStr) => {
                      dispatch({
                        type: 'meetingList/setFilter',
                        payload: {endDate: dateStr, endDateMoment: moment}
                      });
                    }}
                  />
                  <Input
                    className="meeting_name_input"
                    placeholder={intl.formatMessage({
                      id: 'meeting_placeholder_name_id'
                    })}
                    value={meetingList.filter.name}
                    onChange={e => {
                      dispatch({
                        type: 'meetingList/setFilter',
                        payload: {name: e.target.value}
                      });
                    }}
                  />
                  <MoreMeeting
                    meetingTree={meetingTree}
                    intl={intl}
                    selected={meetingList.filter.roomIds}
                    searchPlaceholder={intl.formatMessage({
                      id: 'meeting_placeholder_room'
                    })}
                    onMeetingChange={v => {
                      dispatch({
                        type: 'meetingList/setFilter',
                        payload: {roomIds: v}
                      });
                    }}
                  />
                  <div className="search_btn_div">
                    <div
                      className="meeting_button button_ghost btn_reset"
                      onClick={() => {
                        dispatch({type: 'meetingList/reset', payload: {}});
                      }}
                    >
                      <FormattedMessage id="index_reset"/>
                    </div>
                    <div
                      className="meeting_button button_primary"
                      onClick={() => {
                        dispatch({type: 'meetingList/search', payload: {}});
                      }}
                    >
                      <FormattedMessage id="index_search"/>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            <div style={{margin: 25, marginBottom: 0}}>
              <Button
                type="primary"
                disabled={!hasSelected}
                onClick={(record) => {
                  this.start;
                  Modal.confirm({
                    title: '',
                    content: intl.formatMessage({
                      id: 'meeting_manage_batchCancel_meeting_msg'
                    }),
                    okText: intl.formatMessage({id: 'modal_manage_btn_ok'}),
                    cancelText: intl.formatMessage({
                      id: 'modal_manage_btn_cancel'
                    }),
                    onOk: () => {
                      const promise = new Promise((resolve, reject) => {
                        dispatch({
                          type: 'meetingList/cancelBatchMeeting',
                          meetingData: this.state.selectedMeetingData,
                          name: this.state.name,
                          resolve,
                          reject
                        });
                      });
                      promise.then(() => {
                        Modal.success({
                          content: intl.formatMessage({id: 'cancel_meeting_success'}),
                          okText: intl.formatMessage({id: 'dialog_btn_ok'})
                        });
                        this.setState({selectedMeetingIds: []});
                      }, msg => {
                        Modal.error({content: msg});
                      });
                    }
                  });
                }
                }
              >
                {intl.formatMessage({id: 'room_manage__meeting_batchCancel'})}
              </Button>
              <span style={{marginLeft: 8, color: 'gray'}}>
                {hasSelected ? intl.formatMessage({id: 'meeting_list_selected_meeting_desc'}, {num: this.state.selectedMeetingIds.length}) : ''}
              </span>
            </div>
            <Table
              rowKey={record => record.id}
              dataSource={data.list}
              columns={columns}
              rowSelection={rowSelection}
              pagination={pagination}
            />
          </div>
        </Spin>
      </div>
    );
  }

  /**
   * 获取待审核会议的审批拒绝信息
   * @param meetingAudits
   * @return {*}
   */
  getRejectRemark = (meetingAudits = []) => {
    const rejectRecords = meetingAudits.filter(r => r.status === MEETING_AUDIT_STATUS.reject);
    return rejectRecords.length > 0 ? rejectRecords[0].remark : '';
  };

  cancelMeetingConfirm = record => {
    const {intl} = this.props;
    const $this = this;
    const message = (
      <span>
        <input
          style={{float: 'left', marginTop: '3px'}}
          defaultValue="false"
          type="checkbox"
          ref={ref => {
            this.loopCheckBox = ref;
          }}
        />{' '}
        &nbsp;
        <span>
          {this.props.intl.formatMessage({
            id: 'cancel_loop_meeting'
          })}
        </span>
      </span>
    );

    if (record.type > 0) {
      Modal.confirm({
        content: message,
        cancelText: $this.props.intl.formatMessage({
          id: 'btn_close'
        }),
        onOk: () => {
          let type = record.type;
          if (
            $this.loopCheckBox &&
            !$this.loopCheckBox.checked
          ) {
            type = 0;
          }
          $this.cancelMeeting(record, type);
        }
      });
    } else {
      Modal.confirm({
        title: '',
        content: intl.formatMessage({
          id: 'meeting_list_operate_cancelText'
        }),
        okText: intl.formatMessage({id: 'mc_btn_ok'}),
        cancelText: intl.formatMessage({
          id: 'mc_btn_cancel'
        }),
        onOk: () => {
          $this.cancelMeeting(record, record.type);
        }
      });
    }
  };

  closeMeetingConfirm = record => {
    const {intl} = this.props;
    const $this = this;
    Modal.confirm({
      title: '',
      content: intl.formatMessage({
        id: 'meeting_list_operate_stopText'
      }),
      okText: intl.formatMessage({id: 'mc_btn_ok'}),
      cancelText: intl.formatMessage({id: 'mc_btn_cancel'}),
      onOk: () => {
        $this.closeMeeting(record);
      }
    });
  };

  tableOperateRender = record => {
    const {intl, dispatch, userInfo} = this.props;
    const $this = this;
    const {status, rooms, maxDelayTimeConf} = record;
    const cmmaFlag = this.checkCmmaFlag(record);
    let usage = 0;
    rooms.map(r => {
      if (r.visible == 1) {
        usage = 1;
      }
    });

    if (checkOperateAuth(record, userInfo)) {
      const operateIcons = [];
      if (status === MEETING_STATUS.pending
        || status === MEETING_STATUS.reject) {
        operateIcons.push(
          <span
            key={operateIcons.length + 1}
            onClick={() => {
              if (cmmaFlag) {
                const promise = new Promise((resolve, reject) => {
                  dispatch({
                    type: 'meetingControl/checkCmmaStatus',
                    resolve,
                    reject,
                    payload: record.id
                  });
                });
                promise.then(
                  (data) => {
                    if (data) {
                      Modal.confirm({
                        title: intl.formatMessage({
                          id: 'meeting_cancel_cmma_title'
                        }),
                        content: intl.formatMessage({
                          id: 'meeting_cancel_cmma_text'
                        }),
                        okText: intl.formatMessage({id: 'dialog_btn_know'}),
                        cancelText: intl.formatMessage({
                          id: 'mc_btn_cancel'
                        }),
                        onOk: () => {
                          this.cancelMeetingConfirm(record);
                        }
                      });
                    } else {
                      this.cancelMeetingConfirm(record);
                    }
                  },
                  () => {
                    this.cancelMeetingConfirm(record);
                  }
                );
              } else {
                this.cancelMeetingConfirm(record);
              }
            }}
          >
            {intl.formatMessage({id: 'mc_btn_cancel'})}
          </span>
        );
      }

      cmmaFlag && operateIcons.push(
        <span
          key={operateIcons.length + 1}
          onClick={() =>
            dispatch(
              routerRedux.push(
                pathToRegexp.compile(PATHS.meetingCtrl)({
                  meetingId: String(record.id)
                })
              )
            )
          }
        >
          {intl.formatMessage({
            id: 'meeting_control_btn'
          })}
        </span>
      );

      if (status === MEETING_STATUS.opened) {
        operateIcons.push(
          maxDelayTimeConf && <span
            key={operateIcons.length + 1}
            onClick={() => {
              const delayArray = maxDelayTimeConf.split('|');
              const maxDelay = delayArray.length > 0 ? delayArray[delayArray.length - 1] : 60;
              const minDelay = delayArray.length > 1 ? delayArray[0] : 15;
              this.setState({
                delayModal: true,
                delayArray: delayArray,
                delayModalMinute: maxDelay,
                maxDelay: maxDelay,
                minDelay: minDelay,
                currentMeetingId: record.id
              });
            }}
          >
          {intl.formatMessage({id: 're_extend'})}
          </span>
        );
        operateIcons.push(
          <span
            key={operateIcons.length + 1}
            onClick={() => {
              if (cmmaFlag) {
                const promise = new Promise((resolve, reject) => {
                  dispatch({
                    type: 'meetingControl/checkCmmaStatus',
                    resolve,
                    reject,
                    payload: record.id
                  });
                });
                promise.then(
                  (data) => {
                    if (data) {
                      Modal.confirm({
                        title: intl.formatMessage({
                          id: 'meeting_cancel_cmma_title'
                        }),
                        content: intl.formatMessage({
                          id: 'meeting_cancel_cmma_text'
                        }),
                        okText: intl.formatMessage({id: 'dialog_btn_know'}),
                        cancelText: intl.formatMessage({
                          id: 'mc_btn_cancel'
                        }),
                        onOk: () => {
                          this.closeMeetingConfirm(record);
                        }
                      });
                    } else {
                      this.closeMeetingConfirm(record);
                    }
                  },
                  () => {
                    this.closeMeetingConfirm(record);
                  }
                );
              } else {
                this.closeMeetingConfirm(record);
              }
            }}
          >
     {intl.formatMessage({id: 're_end'})}
          </span>
        );
      }
      if (
        status === MEETING_STATUS.closed ||
        status === MEETING_STATUS.cancel
      ) {
        if (0 == usage) {
          operateIcons.push(
            <span
              key={operateIcons.length + 1}
              onClick={() => {
                dispatch({
                  type: 'meetingList/bookAgain',
                  meetingId: record.id
                });
              }}
            >
              {intl.formatMessage({
                id: 'meeting_list_operate_book_again'
              })}
            </span>
          );
        }
      }
      return <div className="meeting_table_operate">{operateIcons}</div>;
    } else {
      return null;
    }
  };

  cancelMeeting = (record, type) => {
    this.props.dispatch({
      type: 'meetingList/cancelMeeting',
      payload: {...record, ...{type}}
    });
  };

  delayMeeting = record => {
    this.props.dispatch({type: 'meetingList/delayMeeting', payload: record});
  };

  closeMeeting = record => {
    this.props.dispatch({type: 'meetingList/closeMeeting', payload: record});
  };

  // 检查是否显示会控功能入口按钮
  checkCmmaFlag = meeting => {
    const {
      cmmaMeeting,
      creatorId,
      status,
      signTime,
      startTime,
      meetingCtrl: {conferenceId}
    } = meeting;
    if (cmmaMeeting !== 1) return false;
    const {userInfo = {}} = this.props;
    const {userId = '', roleKey = ''} = userInfo;
    // 会议开始前指定时间范围内，可以看到会控按钮
    const allowCtrl =
      (startTime - new Date(Date.now())) / (1000 * 60) <= signTime;
    const hasCmmaId = conferenceId && conferenceId !== '';
    // 先决条件
    if (creatorId === userId || roleKey === ROLES_KEY.room_admin) {
      if (
        (status === 0 && allowCtrl) || // 会议未开始
        status === 1 || // 会议正在进行
        (status === 2 && hasCmmaId) || // 会议已结束
        (status === 3 && hasCmmaId) // 会议已取消
      ) {
        return true;
      }
    }
    return false;
  };
}

MeetingList.defaultProps = {
  total: 0,
  currentPage: 1,
  pageSize: 10
};
export default MeetingList;



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingList.js